var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isPc)?_c('HomePc'):_c('HomeM')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }